import reactionLike from "../static/reaction_like.svg";
import reactionLove from "../static/reaction_love.svg";
import reactionHaha from "../static/reaction_haha.svg";
import reactionWow from "../static/reaction_wow.svg";
import reactionSad from "../static/reaction_sad.svg";
import reactionAngry from "../static/reaction_angry.svg";

import logoUrl from "../static/logo.png";
import headerBg from "../static/header_bg.png";
import portalHn from "../static/portal_hn.jpeg";
import portalSg from "../static/portal_sg.jpeg";
import portalOther from "../static/portal_other.jpg";

import mobileNavIconForum from "../static/mobile_nav_icon_forum.png";
import mobileNavIconFriend from "../static/mobile_nav_icon_friend.png";
import mobileNavIconVideo from "../static/mobile_nav_icon_video.png";
import mobileNavIconVip from "../static/mobile_nav_icon_vip.png";
import {getCurrentBaseUrl} from "../utils/utils";

export const development = false;

export const TITLE = 'Gái gọi - Gái gọi cao cấp - Checkerviet';
export const DESCRIPTION = 'Gái gọi cao cấp Hà Nội, Sài Gòn trang web tìm gai goi cao cap tốt nhất tại Việt Nam. Chúng tôi chỉ có những cô gái THẬT tại Ha Noi, Sai Gon, Đà Nẵng, Hải Phòng...';

export const VIDEO_TITLE = 'Gái Gọi Videos';
export const VIDEO_DESCRIPTION = 'Gái Gọi Có Videos - chia sẻ videos các e gái gọi, gái gọi cao cấp, gái gọi hà nội, gái gọi sài gòn, gái gọi đà nẵng, gái gọi bình dương, gái gọi đồng nai, gái gọi đà lạt, gái gọi vũng tàu, gái gọi nha trang, gái gọi cần thơ và các thành phố khác.';

export const sidebarAds1 = 'https://i.imgur.com/7xKlbT1.png';
export const sidebarAds2 = 'https://i.imgur.com/OIsGuuo.png';

// API
export const boardUrl = (development) ? 'http://localhost/knv_2024' : getCurrentBaseUrl();

export const appUrl = (development) ? 'http://localhost:3000' : boardUrl;
export const API_KEY = 'JlgjhGT_mtduiAW5BqPoia5oMfl5WJSl';
export const API_BASE_URL = `${boardUrl}/api`;

// Reactions
export const reactionIconSize = 48;
export const reaction = (reactionId) => {
	switch (reactionId) {
		case 1:
			return {
				node: <div className="reaction-icon">
					<img src={reactionLike} height={reactionIconSize} alt="Like"/>
				</div>,
				label: 'Like'
			};
		case 2:
			return {
				node: <div className="reaction-icon">
					<img src={reactionLove} height={reactionIconSize} alt="Love"/>
				</div>,
				label: 'Love'
			};
		case 3:
			return {
				node: <div className="reaction-icon">
					<img src={reactionHaha} height={reactionIconSize} alt="Haha"/>
				</div>,
				label: 'Haha'
			};
		case 4:
			return {
				node: <div className="reaction-icon">
					<img src={reactionWow} height={reactionIconSize} alt="Wow"/>
				</div>,
				label: 'Wow'
			};
		case 5:
			return {
				node: <div className="reaction-icon">
					<img src={reactionSad} height={reactionIconSize} alt="Sad"/>
				</div>,
				label: 'Sad'
			};
		case 6:
			return {
				node: <div className="reaction-icon">
					<img src={reactionAngry} height={reactionIconSize} alt="Angry"/>
				</div>,
				label: 'Angry'
			};
	}
}

export const reactions = [
	{
		label: "Like",
		node: reaction(1).node,
		key: 1
	},
	{
		label: "Love",
		node: reaction(2).node,
		key: 2
	},
	{
		label: "Haha",
		node: reaction(3).node,
		key: 3
	},
	{
		label: "Wow",
		node: reaction(4).node,
		key: 4
	},
	{
		label: "Sad",
		node: reaction(5).node,
		key: 5
	},
	{
		label: "Angry",
		node: reaction(6).node,
		key: 6
	}
]

// Navigation
export const NavigationItems = [
	{
		id: 'home',
		title: 'Trang chủ',
		url: boardUrl,
	},
	{
		id: 'forum',
		title: 'Diễn đàn',
		url: `${boardUrl}/forums`
	},
	{
		id: 'category-hanoi',
		title: 'Gái gọi Hà Nội',
		url: `${boardUrl}/gai-goi-ha-noi`
	},
	{
		id: 'category-saigon',
		title: 'Gái gọi Sài Gòn',
		url: `${boardUrl}/gai-goi-sai-gon`
	},
	{
		id: 'category-other',
		title: 'Gái gọi các Thành Phố Khác',
		url: `${boardUrl}/gai-goi-thanh-pho-khac`
	},
	{
		id: 'video',
		title: 'Gái gọi Videos',
		url: `${boardUrl}/videos`
	},
	{
		id: 'post-manager',
		title: 'Quản lý tin đăng',
		url: `${boardUrl}/post-manager`
	},
];

export {
	logoUrl,
	headerBg,
	portalHn,
	portalSg,
	portalOther,
	mobileNavIconForum,
	mobileNavIconFriend,
	mobileNavIconVideo,
	mobileNavIconVip,
}